import Joi from "joi";
export const createUserSchema = (lang) => {
  const language = lang === "AR" ? "arabic" : "english";
  const joiMessage = require(`../../translate/${language}/joi.json`);

  const schema = {
    initialData: {
      firstName: null,
      secondName: null,
      email: null,
      role: null,
    },
    schema: Joi.object({
      firstName: Joi.string().required().min(1).max(15).messages({
        "string.empty": joiMessage.common.required,
        "string.base": joiMessage.office.full_name.invalid,
        "string.min": joiMessage.office.full_name.min,
        "string.max": joiMessage.office.full_name.max,
      }),
      secondName: Joi.string().required().min(1).max(15).messages({
        "string.empty": joiMessage.common.required,
        "string.base": joiMessage.office.full_name.invalid,
        "string.min": joiMessage.office.full_name.min,
        "string.max": joiMessage.office.full_name.max,
      }),
      email: Joi.string()
        .email({ tlds: { allow: false } })
        .required()
        .messages({
          "string.empty": joiMessage.common.required,
          "string.base": joiMessage.office.email.invalid,
          "string.email": joiMessage.office.email.invalid,
        }),

      role: Joi.string().required().valid("ADMIN", "EMPLOYEE").messages({
        "string.empty": joiMessage.common.required,
        "string.base": joiMessage.office.role.invalid,
        "string.only": joiMessage.office.role.invalid,
        "string.requied": joiMessage.office.role.invalid,
      }),
    }),
    explicitCheck: {
      firstName: false,
      secondName: false,
      email: false,
      role: false,
    },
    validationOptions: {
      abortEarly: true,
    },
  };
  return { schema: schema };
};
